import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MapService } from '../../map.service';

@Component({
  selector: 'app-zoom-buttons',
  templateUrl: './zoom-buttons.component.html',
  host: {
    class: 'floating-box e-flex e-flex-direction-column e-gap-8 e-p-8',
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ZoomButtonsComponent {
  private readonly mapService = inject(MapService);

  protected zoomIn() {
    return this.mapService.map()?.nativeElement.zoomIn();
  }

  protected zoomOut() {
    return this.mapService.map()?.nativeElement.zoomOut();
  }
}
